import {Row, Col} from 'react-bootstrap';
import FormTextInput from "../../common/components/FormTextInput";
import React, {Component, useEffect, useState} from 'react';
import defaultConfig from './organization-default-config.json';
import OrganizationConfigForm from "./OrganizationConfigForm";

import isEmail from 'validator/es/lib/isEmail';

export default function OnboardOrganizationForm(props) {
    // Load props
    const orgConfig = props.props.orgConfigProp;
    const setOrgConfig = props.props.setOrgConfigProp;
    const setOrgSubscription = props.props.setOrgSubscription;
    const formValid = props.props.formValidProp;
    const defaultSubscription = props.props.orgSubscriptionProp;

    // Set state variables
    const [orgName, setOrgName] = useState('');
    const [ownerName, setOwnerName] = useState('');
    const [ownerSurname, setOwnerSurname] = useState('');
    const [ownerEmail, setOwnerEmail] = useState('');
    const [config, setConfig] = useState(defaultConfig);
    const [subscription, setSubscription] = useState(defaultSubscription);

    useEffect(() => {
        // When form fields are updated, update the JSON representation
        const data = {
            name: orgName,
            config: config,
            subscription: subscription,
            owner: {
                givenName: ownerName,
                surName: ownerSurname,
                credentials: {
                    email: ownerEmail
                }
            }
        }
        setOrgConfig(null); // We don't have organization config yet. All values are moved to subscription field.
        setOrgSubscription(data);
    }, [config, subscription, orgName, ownerEmail, ownerName, ownerSurname, setOrgConfig, setOrgSubscription]);

    return (<div>
        <p hidden id='jsonInputTxt'>{JSON.stringify(orgConfig)}</p>
            <div className="organization-section">
                <Row>
                    <Col md={12}>
                        <div id="organization-name-div">
                            <FormTextInput
                                label={'Organization Name'}
                                placeholder="Enter organization name"
                                value={orgName}
                                onChange={value => setOrgName(value)}
                                // isInvalid={!formValid && !orgName}
                                size={'sm'}
                                required
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div id="owner-name-div">
                            <FormTextInput
                                label={'Owner Given Name'}
                                placeholder="Enter owner given Name"
                                value={ownerName}
                                onChange={value => setOwnerName(value)}
                                isInvalid={!formValid && !ownerName}
                                size={'sm'}
                                required
                            />
                        </div>
                    </Col>
                    <Col md={6}>
                        <div id="owner-surname-div">
                            <FormTextInput
                                label={'Owner Surname'}
                                placeholder="Enter owner surname"
                                value={ownerSurname}
                                onChange={value => setOwnerSurname(value)}
                                isInvalid={!formValid && !ownerSurname}
                                size={'sm'}
                                required
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div id="owner-email-div">
                            <FormTextInput
                                label={'Owner Email'}
                                placeholder="Enter email"
                                value={ownerEmail}
                                onChange={value => setOwnerEmail(value)}
                                isInvalid={!formValid && (!ownerEmail || !isEmail(ownerEmail))}
                                size={'sm'}
                                required
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div id="owner-email-div">
                            <OrganizationConfigForm
                                setSubscription={setSubscription}
                                setConfig={setConfig}
                                formValid={formValid}
                                defaultSubscription={defaultSubscription}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
    </div>);
}
